import {stringToAttributeId} from './components/spc/util/spcUtils';

const lineColumn = [
	[
		'root::CX_Region'
	],
	[
		'root::HS_Construction'
	],
	[
		'root::HS_LightEmission',
		'root::HS_LightEmissionCAFilter',
	],
	[
		'root::LE_LightEngineModuleSize_1',
		'root::LE_LightEngineModuleSize_2',
		'root::LE_LightDistribution_1',
		'root::LE_LightDistribution_2',
		'root::LE_ColourTemperature_1',
		'root::LE_ColourTemperature_2',
		'root::LE_ReflectorColour_1',
		'root::LE_ReflectorColour_2',
		'root::LE_OpticalVersion_1',
		'root::LE_OpticalVersion_2'
	],
	[
		'root::HS_HousingColour',
		'root::HS_HousingHeight',
		'root::HS_HousingMountingLocationEBlock_1',
		'root::HS_HousingMountingLocationEBlock_2',
		'root::HS_Base',
	],
	[
		'root::EB_Control_1',
		'root::EB_Control_2',
		'root::EB_ElectricalProtectionClass_1',
		'root::EB_ElectricalProtectionClass_2',
		'root::EB_Zhaga_1',
		'root::EB_Zhaga_2',
		'root::EB_ConstantLumenTechnology_1',
		'root::EB_ConstantLumenTechnology_2'
	],
	[
		'root::HS_HousingCoating',
		'root::HS_HousingPowerConnection',
		'root::HS_HousingType'
	],
	[
		'root::HS_LightEmissionCA',
		'root::HS_UpLight',
	]
];
const lineBollard = [
	[
		'root::CX_Region'
	],
	[
		'root::HS_Construction'
	],
	[
		'root::HS_LightEmission',
		'root::HS_LightEmissionCAFilter',
	],
	[
		'root::LE_LightEngineModuleSize_1',
		'root::LE_LightEngineModuleSize_2',
		'root::LE_LightDistribution_1',
		'root::LE_LightDistribution_2',
		'root::LE_ColourTemperature_1',
		'root::LE_ColourTemperature_2',
		'root::LE_ReflectorColour_1',
		'root::LE_ReflectorColour_2',
		'root::LE_OpticalVersion_1',
		'root::LE_OpticalVersion_2'
	],
	[
		'root::HS_HousingColour',
		'root::HS_HousingHeight',
		'root::HS_HousingMountingLocationEBlock_1',
		'root::HS_HousingMountingLocationEBlock_2',
		'root::HS_Base',
	],
	[
		'root::EB_Control_1',
		//'root::EB_Control_2',
		'root::EB_ElectricalProtectionClass_1',
		//'root::EB_ElectricalProtectionClass_2',
		'root::EB_Zhaga_1',
		//'root::EB_Zhaga_2',
		'root::EB_ConstantLumenTechnology_1',
		//'root::EB_ConstantLumenTechnology_2'
	],
	[
		'root::HS_HousingCoating',
		'root::HS_HousingPowerConnection',
		'root::HS_HousingType'
	],
	[
		'root::HS_LightEmissionCA',
		'root::HS_UpLight',
	],

];

const lineSingular = [
	[
		'root::CX_Region'
	],
	[
		'root::HS_LightEmissionCAFilter',
		'root::HS_LightEmission',
	],
	[
		'root::LE_LightEngineModuleSize_1',
		'root::LE_LightDistribution_1',
		'root::LE_ColourTemperature_1',
		'root::LE_ReflectorColour_1',
		'root::LE_OpticalVersion_1',
	],
	[
		'root::HS_HousingColour',
		'root::HS_HousingHeight',
		'root::HS_HousingMountingLocationEBlock_1',
		'root::HS_Base',
	],
	[
		'root::EB_Control_1',
		'root::EB_ElectricalProtectionClass_1',
		'root::EB_Zhaga_1',
		'root::EB_ConstantLumenTechnology_1',
	],
	[
		'root::HS_HousingCoating',
		'root::HS_HousingPowerConnection',
		'root::HS_HousingType'
	],
	[
		'root::HS_LightEmissionCA',
		'root::HS_UpLight',
	],
];

const lineColumnIntern = [
	[
		'root::CX_Region'
	],
	[
		'root::HS_Construction'
	],
	[
		'root::HS_LightEmissionCAFilter',
		'root::HS_LightEmission',
	],
	[
		'root::HS_HousingColour',
		'root::HS_HousingHeight',
		'root::HS_Base',
	],
	[
		'root::HS_HousingCoating',
		'root::HS_HousingPowerConnection',
		'root::HS_HousingType'
	],
	[
		'root::HS_HousingMountingLocationEBlock_1',
	],
	[
		'root::LE_ColourTemperature_1',
		'root::LE_DimmingLevel_1',
		'root::LE_LightDistribution_1',
		'root::LE_LuminousFlux_1',
		'root::LE_LightEngineModuleSize_1',
		'root::LE_OpticalVersion_1',
		'root::LE_ReflectorColour_1',
	],
	[
		'root::EB_ConstantLumenTechnology_1',
		'root::EB_Control_1',
		'root::EB_EBlockMountingType_1',
		'root::EB_ElectricalProtectionClass_1',
		'root::EB_Wattage_1',
		'root::EB_Zhaga_1'
	],
	[
		'root::HS_HousingMountingLocationEBlock_2',
	],

	[
		'root::LE_ColourTemperature_2',
		'root::LE_DimmingLevel_2',
		'root::LE_LightDistribution_2',
		'root::LE_LuminousFlux_2',
		'root::LE_LightEngineModuleSize_2',
		'root::LE_OpticalVersion_2',
		'root::LE_ReflectorColour_2',
	],
	[
		'root::EB_ConstantLumenTechnology_2',
		'root::EB_Control_2',
		'root::EB_EBlockMountingType_2',
		'root::EB_ElectricalProtectionClass_2',
		'root::EB_Wattage_2',
		'root::EB_Zhaga_2'
	],
	[
		'root::HS_LightEmissionCA',
		'root::HS_UpLight',
	],


];
const lineBollardIntern = [
	[
		'root::CX_Region'
	],
	[
		'root::HS_Construction'
	],
	[
		'root::HS_LightEmissionCAFilter',
		'root::HS_LightEmission',
	],
	[
		'root::HS_HousingColour',
		'root::HS_HousingHeight',
		'root::HS_Base',
	],
	[
		'root::HS_HousingCoating',
		'root::HS_HousingPowerConnection',
		'root::HS_HousingType'
	],
	[
		'root::HS_HousingMountingLocationEBlock_1',
		'root::HS_HousingMountingLocationEBlock_2',
	],
	[
		'root::LE_ColourTemperature_1',
		'root::LE_DimmingLevel_1',
		'root::LE_LightDistribution_1',
		'root::LE_LuminousFlux_1',
		'root::LE_LightEngineModuleSize_1',
		'root::LE_OpticalVersion_1',
		'root::LE_ReflectorColour_1',
	],
	[
		'root::LE_ColourTemperature_2',
		'root::LE_DimmingLevel_2',
		'root::LE_LightDistribution_2',
		'root::LE_LuminousFlux_2',
		'root::LE_LightEngineModuleSize_2',
		'root::LE_OpticalVersion_2',
		'root::LE_ReflectorColour_2',
	],

	[
		'root::EB_ConstantLumenTechnology_1',
		'root::EB_Control_1',
		'root::EB_EBlockMountingType_1',
		'root::EB_ElectricalProtectionClass_1',
		'root::EB_Wattage_1',
		'root::EB_Zhaga_1'
	],
	[
		'root::HS_LightEmissionCA',
		'root::HS_UpLight',
	],

];

const lineSingularIntern = [
	[
		'root::CX_Region'
	],
	[
		'root::HS_LightEmission',
		'root::HS_LightEmissionCAFilter',
	],
	[
		'root::HS_HousingColour',
		'root::HS_HousingHeight',
		'root::HS_Base',
	],
	[
		'root::HS_HousingCoating',
		'root::HS_HousingPowerConnection',
		'root::HS_HousingType'
	],
	[
		'root::LE_ColourTemperature_1',
		'root::LE_DimmingLevel_1',
		'root::LE_LightDistribution_1',
		'root::LE_LuminousFlux_1',
		'root::LE_LightEngineModuleSize_1',
		'root::LE_OpticalVersion_1',
		'root::LE_ReflectorColour_1',
	],
	[
		'root::EB_ConstantLumenTechnology_1',
		'root::EB_Control_1',
		'root::EB_EBlockMountingType_1',
		'root::EB_ElectricalProtectionClass_1',
		'root::EB_Wattage_1',
		'root::EB_Zhaga_1'
	],
	[
		'root::HS_UpLight',
		'root::HS_LightEmissionCA',
	],
	[
		'root::HS_HousingMountingLocationEBlock_1',
	],
];


const aeto = [
	[
		'root::CX_Region'
	],
	[
		'root::LE_ColourTemperature_1',
	],
	[
		'root::LE_ColourTemperature_2'
	],
	[
		'root::EB_MotionSensor_1'
	],
	[
		'root::HS_Construction',
		'root::HS_HousingSize',
		'root::LU_SolarUnitHeight'
	],
	[
		'root::HS_HousingHeight'
	],
	[
		'root::LE_LuminairePositionHeight_1',
		'root::LE_LightDistribution_1',
	],
	[
		'root::LE_LuminairePositionHeight_2',
		'root::LE_LightDistribution_2'
	],
	[
		'root::LE_LuminairePositionAngle_1',
		'root::LE_LuminairePositionAngle_2',
		'root::LE_LuminairePositionHeightSU_1',
		'root::LE_LuminairePositionHeightSU_2',
		'root::LU_SolarUnit'
	]
];

const olivio = [
	[
		'root::CX_Region'
	],
	[
		'root::HS_HousingSize',
	],
	[
		'root::HS_CircularBaseProfile',
	],
	[
		'root::LE_LightDistribution_1',
		'root::LE_ColourTemperature_1',
		'root::LE_ReflectorColour_1'
	],
	[
		'root::LE_Accessories_1'
	],
	[
		'root::EB_Control_1',
		'root::EB_ConstantLumenTechnology_1',
		'root::EB_Zhaga_1',
		'root::EB_ElectricalProtectionClass_1',
		'root::LE_DimmingLevel_1',
	]
];

const aira = [
	[
		'root::CX_Region'
	],
	[
		'root::HS_CircularBaseProfile',
		'root::LE_OpticalVersion_1'
	],
	[
		'root::HS_HousingSize',
		'root::LE_LightEngineModuleSize_1',
		'root::LE_ReflectorColour_1'
	],
	[
		'root::LE_LightDistribution_1',
		'root::LE_ColourTemperature_1',
	],
	[
		'root::LE_DimmingLevel_1',
	]
];
const alpha = [
	[
		'root::CX_Region'
	],
	[
		'root::HS_CircularBaseProfile',
	],
	[
		'root::LE_LightEngineModuleSize_1',
		'root::LE_ReflectorColour_1'
	],
	[
		'root::LE_LightDistribution_1',
		'root::LE_ColourTemperature_1',
	],
	[
		'root::LE_DimmingLevel_1',
	]
];
const anatar = [
	[
		'root::CX_Region'
	],
	[
		'root::HS_HousingSize',
	],
	[
		'root::HS_CircularBaseProfile',
	],
	[
		'root::LE_LightDistribution_1',
		'root::LE_ColourTemperature_1',
	],
	[
		'root::LE_DimmingLevel_1',
	]
];
const arca = [
	[
		'root::CX_Region'
	],
	[
		'root::HS_CircularBaseProfile',
	],
	[
		'root::LE_LightDistribution_1',
		'root::LE_ColourTemperature_1',
	],
	[
		'root::LE_DimmingLevel_1',
	]
];
const astro = [
	[
		'root::CX_Region'
	],
	[
		'root::HS_HousingSize',
	],
	[
		'root::HS_CircularBaseProfile',
	],
	[
		'root::LE_OpticalVersion_1',
		'root::LE_LightEngineModuleSize_1',
	],
	[
		'root::LE_LightDistribution_1',
		'root::LE_ColourTemperature_1',
	],
	[
		'root::LE_DimmingLevel_1',
	]
];
const avanza = [
	[
		'root::CX_Region'
	],
	[
		'root::HS_CircularBaseProfile',
	],
	[
		'root::HS_HousingSize',
	],
	[
		'root::LE_OpticalVersion_1',
	],
	[
		'root::LE_LightDistribution_1',
		'root::LE_ColourTemperature_1',
	],
	[
		'root::LE_DimmingLevel_1',
	]
];
const axeo = [
	[
		'root::CX_Region'
	],
	[
		'root::HS_HousingSize',
	],
	[
		'root::HS_CircularBaseProfile',
	],
	[
		'root::LE_LightEngineModuleSize_1',
	],
	[
		'root::LE_LightDistribution_1',
		'root::LE_ColourTemperature_1',
	],
	[
		'root::LE_DimmingLevel_1',
	]
];
const aya = [
	[
		'root::CX_Region'
	],
	[
		'root::HS_HousingSize',
	],
	[
		'root::HS_CircularBaseProfile',
	],
	[
		'root::LE_LightDistribution_1',
		'root::LE_ColourTemperature_1',
	],
	[
		'root::LE_DimmingLevel_1',
	]
];
const beta = [
	[
		'root::CX_Region'
	],
	[
		'root::HS_HousingSize'
	],
	[
		'root::HS_CircularBaseProfile',
	],
	[
		'root::LE_ColourTemperature_1',
	],
	[
		'root::LE_DimmingLevel_1',
	]
];
const discera = [
	[
		'root::CX_Region'
	],
	[
		'root::HS_HousingSize',
	],
	[
		'root::HS_CircularBaseProfile',
	],
	[
		'root::LE_LightEngineModuleSize_1',
	],
	[
		'root::LE_LightDistribution_1',
		'root::LE_ColourTemperature_1',
	],
	[
		'root::LE_DimmingLevel_1',
	]
];
const elo = [
	[
		'root::CX_Region'
	],
	[
		'root::HS_HousingSize'
	],
	[
		'root::HS_CircularBaseProfile',
	],
	[
		'root::LE_LightEngineModuleSize_1',
		'root::LE_ReflectorColour_1'
	],
	[
		'root::LE_LightDistribution_1',
	],
	[
		'root::LE_ColourTemperature_1',
	],
	[
		'root::LE_DimmingLevel_1',
	]
];
const inula = [
	[
		'root::CX_Region'
	],
	[
		'root::HS_HousingSize'
	],
	[
		'root::HS_CircularBaseProfile',
	],
	[
		'root::LE_LightEngineModuleSize_1',
	],
	[
		'root::LE_LightDistribution_1',
		'root::LE_ColourTemperature_1',
	],
	[
		'root::LE_DimmingLevel_1',
	]
];
const jessica = [
	[
		'root::CX_Region'
	],
	[
		'root::HS_HousingSize'
	],
	[
		'root::HS_CircularBaseProfile',
	],
	[
		'root::LE_LightEngineModuleSize_1',
		'root::LE_ColourTemperature_1',
	],
	[
		'root::LE_DimmingLevel_1',
	]
];
const lanova = [
	[
		'root::CX_Region'
	],
	[
		'root::HS_HousingSize'
	],
	[
		'root::HS_CircularBaseProfile',
	],
	[
		'root::LE_LightDistribution_1',
		'root::LE_ColourTemperature_1',
	],
	[
		'root::LE_DimmingLevel_1',
	]
];
const lif = [
	[
		'root::CX_Region'
	],
	[
		'root::HS_HousingSize'
	],
	[
		'root::HS_CircularBaseProfile',
	],
	[
		'root::LE_ColourTemperature_1',
		'root::LE_LightEngineModuleSize_1',
		'root::LE_ReflectorColour_1',
		'root::LE_LightDistribution_1'
	],
	[
		'root::LE_DimmingLevel_1',
	]
];
const lifPath = [
	[
		'root::CX_Region'
	],
	[
		'root::HS_HousingSize'
	],
	[
		'root::HS_CircularBaseProfile',
	],
	[
		'root::LE_ReflectorColour_1',
		'root::LE_LightDistribution_1'
	],
	[
		'root::LE_DimmingLevel_1',
	]
];
const lukida = [
	[
		'root::CX_Region'
	],
	[
		'root::HS_HousingSize',
	],
	[
		'root::HS_CircularBaseProfile',
	],
	[
		'root::LE_LightDistribution_1',
		'root::LE_ColourTemperature_1',
	],
	[
		'root::LE_DimmingLevel_1',
	]
];
const mistella = [
	[
		'root::CX_Region'
	],
	[
		'root::HS_HousingSize',
	],
	[
		'root::HS_CircularBaseProfile',
	],
	[
		'root::LE_LightDistribution_1',
		'root::LE_ColourTemperature_1',
	],
	[
		'root::LE_DimmingLevel_1',
	]
];
const rondero = [
	[
		'root::CX_Region'
	],
	[
		'root::HS_HousingSize',
	],
	[
		'root::HS_CircularBaseProfile',
	],
	[
		'root::LE_LightEngineModuleSize_1',
		'root::LE_ReflectorColour_1',
	],
	[
		'root::LE_LightDistribution_1',
		'root::LE_ColourTemperature_1',
	],
	[
		'root::LE_DimmingLevel_1',
	]
];
const saturn = [
	[
		'root::CX_Region'
	],
	[
		'root::HS_HousingSize',
	],
	[
		'root::HS_CircularBaseProfile',
	],
	[
		'root::LE_LightEngineModuleSize_1',
		'root::LE_ReflectorColour_1',
	],
	[
		'root::LE_LightDistribution_1',
		'root::LE_ColourTemperature_1',
	],
	[
		'root::LE_DimmingLevel_1',
	]
];
const sombreo = [
	[
		'root::CX_Region'
	],
	[
		'root::HS_HousingSize',
	],
	[
		'root::HS_CircularBaseProfile',
	],
	[
		'root::LE_LightDistribution_1',
		'root::LE_ColourTemperature_1',
	],
	[
		'root::LE_DimmingLevel_1',
	]
];
const tal = [
	[
		'root::CX_Region'
	],
	[
		'root::HS_HousingSize',
	],
	[
		'root::HS_CircularBaseProfile',
	],
	[
		'root::LE_LightEngineModuleSize_1',
	],
	[
		'root::LE_LightDistribution_1',
		'root::LE_ColourTemperature_1',
	],
	[
		'root::LE_DimmingLevel_1',
	]
];
const tessia = [
	[
		'root::CX_Region'
	],
	[
		'root::HS_HousingSize',
	],
	[
		'root::HS_CircularBaseProfile',
	],
	[
		'root::LE_LightEngineModuleSize_1',
	],
	[
		'root::LE_LightDistribution_1',
		'root::LE_ColourTemperature_1',
	],
	[
		'root::LE_DimmingLevel_1',
	]
];
const trigo = [
	[
		'root::CX_Region'
	],
	[
		'root::HS_HousingSize',
	],
	[
		'root::HS_CircularBaseProfile',
	],
	[
		'root::LE_OpticalVersion_1',
	],
	[
		'root::LE_LightDistribution_1',
		'root::LE_ColourTemperature_1',
	],
	[
		'root::LE_DimmingLevel_1',
	]
];
const tritec = [
	[
		'root::CX_Region'
	],
	[
		'root::HS_HousingSize',
	],
	[
		'root::HS_CircularBaseProfile',
	],
	[
		'root::LE_LightEngineModuleSize_1'
	],
	[
		'root::LE_LightDistribution_1',
		'root::LE_ColourTemperature_1',
	],
	[
		'root::LE_DimmingLevel_1',
	]
];
const valetta = [
	[
		'root::CX_Region'
	],
	[
		'root::HS_HousingSize',
	],
	[
		'root::HS_CircularBaseProfile',
	],
	[
		'root::LE_LightDistribution_1',
		'root::LE_ColourTemperature_1',
	],
	[
		'root::LE_DimmingLevel_1',
	]
];
const yloo = [
	[
		'root::CX_Region'
	],
	[
		'root::HS_HousingSize',
	],
	[
		'root::HS_CircularBaseProfile',
	],
	[
		'root::LE_LightEngineModuleSize_1'
	],
	[
		'root::LE_LightDistribution_1',
		'root::LE_ColourTemperature_1',
	],
	[
		'root::LE_DimmingLevel_1',
	]
];

const wizardAttributeRelations = {

	ColumnExtern: lineColumn,
	BollardExtern: lineBollard,

	Twist06Extern: lineSingular,
	Twist12Extern: lineSingular,
	PoleTopExtern: lineSingular,
	PoleLateralExtern: lineSingular,
	WallSurfaceExtern: lineSingular,
	WallRecessedExtern: lineSingular,

	ColumnIntern: lineColumnIntern,
	BollardIntern: lineBollardIntern,

	Twist06Intern: lineSingularIntern,
	Twist12Intern: lineSingularIntern,
	PoleTopIntern: lineSingularIntern,
	PoleLateralIntern: lineSingularIntern,
	WallSurfaceIntern: lineSingularIntern,
	WallRecessedIntern: lineSingularIntern,

	AetoExtern: aeto,

	OlivioExtern: olivio,
	OlivioUniversalExtern: olivio,
	OlivioBollardExtern: olivio,

	AiraPoleTopExtern: aira,
	AiraPendantExtern: aira,
	AiraCatenaryExtern: aira,

	AlphaExtern: alpha,

	AnatarExtern: anatar,

	ArcaExtern: arca,

	AstroExtern: astro,

	AvanzaExtern: avanza,

	AyaPoleTopExtern: aya,
	AyaPendantExtern: aya,
	AyaCatenaryExtern: aya,

	AxeoExtern: axeo,

	BetaPoleTopExtern: beta,
	BetaPendantExtern: beta,

	DisceraExtern: discera,

	EloPoleTopExtern: elo,
	EloBollardExtern: elo,
	EloColumnExtern: elo,
	EloWallSurfaceExtern: elo,

	InulaBollardExtern: inula,
	InulaColumnExtern: inula,

	JessicaExtern: jessica,

	LanovaPoleTopExtern: lanova,
	LanovaCatenaryExtern: lanova,

	LifTopElementExtern: lif,
	LifPathwayModuleExtern: lifPath,
	LifFacadeModule: lif,
	LifTwinspotModule: lif,

	LukidaExtern: lukida,

	MistellaExtern: mistella,

	RonderoExtern: rondero,

	SaturnPoleTopExtern: saturn,
	SaturnBollard: saturn,

	SombreoPoleLateralExtern: sombreo,
	SombreoCatenaryExtern: sombreo,

	TalExtern: tal,

	TessiaExtern: tessia,

	TrigoExtern: trigo,

	TritecReplacementKitsExtern: tritec,

	ValettaExtern: valetta,

	YlooPoleTopExtern: yloo,
	YlooPoleLateralExtern: yloo,
	YlooPendantExtern: yloo,
	YlooCatenaryExtern: yloo,

};

function arrayToWizardAttributeRelations(array) {
	return array.map(a => ({
		attributes: a.map(stringToAttributeId)
	}));
}

export function getWizardAttributeRelations(deploymentName) {
	if (wizardAttributeRelations.hasOwnProperty(deploymentName)) {
		return arrayToWizardAttributeRelations(wizardAttributeRelations[deploymentName]);
	} else {
		return null;
	}
}
